import createLucideIcon from '../createLucideIcon';

const Pause = createLucideIcon('Pause', [
  ['rect', { x: '6', y: '4', width: '4', height: '16', key: '5yltu4' }],
  ['rect', { x: '14', y: '4', width: '4', height: '16', key: 'duxydb' }],
]);

export default Pause;
